<br>
Denna vy används för att avidentifiera all information om en medlem i enlighet med GDPR.<br>
Däremot kommer information om medlemskap, uppdrag/utmärkelser m m finnas kvar för att möjliggöra uttag av statistik.
<br>
<br>
<div style="border:1px solid lightgrey;border-radius:10px;padding:10px;width:500px;">
  <form [formGroup]="form">
    <div class="row">

    <div class="form-group col-md-3">

      <label for="memberId">
        Medlemsid
      </label>
      <input type="text" class="form-control form-control-sm" id="memberId" style="max-width:120px;" formControlName="memberId" required (change)="getMemberInfo()">
    </div>
    <div class="form-group col-md-8">
      <label>&nbsp;</label>
      <button class="btn border" [disabled]="!form.valid" (click)="confirmGDPR()">Aktivera avidentifiering</button>
    </div>



  </div>
    <br>
    <div *ngIf="member">
<div class="row">
<pre>{{imageToShow}}</pre>
      <div *ngIf="imageToShow !== null" class="col-md-3">
        <img src='{{imageToShow}}' width="100px" style="margin-top:1px;border-radius:10px;">
      </div>

      <div *ngIf="imageToShow === null" class="col-md-3">
        <div width="100px" style="margin-top:1px;border-radius:10px;height:150px;font-size:10px;border:1px solid lightgrey;text-align:center;">
        FOTO SAKNAS
        </div>
      </div>

      <div class="col-md-8 ms-3">
        {{member.givenName}} {{member.familyName}} <br>
        {{member.birthday|date:'yyyy-MM-dd'}} <br>
        {{member.homeAddress?.city}} <br>
        <b>{{primaryinstitution?.shortName}} - {{primaryinstitution?.name}}</b>
      </div>
</div>


    </div>
<br>

  </form>
</div>
